export default [
    'authentications/authenticate',
];